import { onUnmounted } from 'vue';

// This function registers an interval and also clears it when the component is unmounted.
export function useInterval(cb: () => void, delay: number): void {
  const embeddedInterval = setInterval(cb, delay);

  onUnmounted(() => {
    if (embeddedInterval) {
      clearInterval(embeddedInterval);
    }
  });
}
